import { isLeft } from "fp-ts/lib/Either"
import { PathReporter } from "io-ts/lib/PathReporter"

import { invalidApiDataError } from "../../../../errors/recognisedErrors"
import {
    ISingleAddress,
    SingleAddress,
} from "../../types/singleApplication/getPlacesTypes"

export const getSingleAddressMapper = {
    /**
     * Maps `single selected address from Place ID` API response into UI data model
     */
    map: (response: unknown): ISingleAddress => {
        // Validate the API response
        const decoded = SingleAddress.decode(response)
        if (isLeft(decoded)) {
            const detail = `Could not validate data from getAddress endpoint: ${PathReporter.report(
                decoded
            ).join("\n")}`
            throw invalidApiDataError(detail)
        }

        const singleAddressSpec: ISingleAddress = decoded.right

        return singleAddressSpec
    },
}
